import { createTopic } from '../lib';
import { z } from 'zod';

const teamRolesNavigatedEventSchema = z.object({
  entityUrn: z.string(),
});

export type TeamRolesNavigatedEvent = z.infer<
  typeof teamRolesNavigatedEventSchema
>;

export const teamRolesNavigatedTopic = createTopic<TeamRolesNavigatedEvent>(
  {
    namespace: 'control-plane',
    name: 'team-roles-navigated',
    description: 'User navigated to the project team roles page',
  },
  teamRolesNavigatedEventSchema,
);
